module.exports = __webpack_public_path__ + "img/s2.53ba4311.png";